<template>
    <CodiceFeanorView tool-module="urlEncoding" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
